import React from 'react';
import { Alert } from 'react-bootstrap';
export default function ClaimStateAlerts(_ref) {
  var _claim$active_change_;
  let {
    claim
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, claim.is_locked ? /*#__PURE__*/React.createElement(Alert, {
    variant: "primary"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, "lock"), " This page is in read-only mode because claim is locked.") : '', claim.active_change_set && !claim.active_change_set.finalized_at ? /*#__PURE__*/React.createElement(Alert, {
    variant: "primary"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, "lock"), " Some actions on this page are unavailable because the claim is under manager QA review.") : '', (_claim$active_change_ = claim.active_change_set) !== null && _claim$active_change_ !== void 0 && _claim$active_change_.finalized_at ? /*#__PURE__*/React.createElement(Alert, {
    variant: "primary"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, "lock"), " Editing is disabled because this claim is pending manager QA review acceptance / rejection.") : '', claim.financials_locked ? /*#__PURE__*/React.createElement(Alert, {
    variant: "primary"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, "lock"), " This page is in read-only mode because claim financials are locked.") : '');
}